import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import AdminLayout from '../../layouts/AdminLayout';
import DuaFormModal from './DuaFormModal';

export default function DuaFormPage() {
  const history = useHistory();
  const { id } = useParams();

  const handleClose = () => {
    history.push('/duas');
  };

  const handleSuccess = () => {
    history.push('/duas');
  };

  return (
    <AdminLayout title={id ? 'Edit Dua' : 'Add Dua'}>
      <DuaFormModal
        open={true}
        duaId={id || null}
        onClose={handleClose}
        onSuccess={handleSuccess}
      />
    </AdminLayout>
  );
}
